<script setup lang="ts">
import { GpAlert, GpCard, GpPasswordInput, GpTextInput } from '@gportal/uikit';
import { ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    password: string;
    isActive?: boolean;
    isImageSupportingPassword?: boolean;
  }>(),
  {
    isActive: false,
    isImageSupportingPassword: false,
  },
);

const emit = defineEmits<{ (e: 'update:password', value: string); (e: 'authTypeSelect') }>();

const handlePasswordInput = (value) => {
  emit('update:password', value);
};

const input = ref<InstanceType<typeof GpTextInput>>();
watch(
  () => props.isActive,
  () => {
    if (props.isActive) {
      const textInput = (input.value.$el as HTMLDivElement).querySelector('input');
      if (textInput != null) {
        textInput.focus();
      }
    } else {
      handlePasswordInput('');
    }
  },
);
</script>

<template>
  <GpCard
    title="Password"
    :enlarge-on-hover="false"
    :active="isActive"
    :class="{ 'tw-cursor-pointer': !isActive }"
    @click="emit('authTypeSelect')"
    v-playwright="`nodes-create-login-password`"
    :aria-selected="isActive"
  >
    <div class="tw-p-4">
      <p class="tw-mb-2 tw-text-xl tw-font-bold">Password</p>
      <GpAlert
        v-if="isActive"
        class="tw-mb-2"
        :alert-type="isImageSupportingPassword ? 'danger' : 'warning'"
        size="sm"
      >
        Please note, the password will be visible as plain text on the meta data endpoints on your
        machine. This allows to read the password by any user (unprivileged) on the server. Please
        change the password immediately after the first login.
      </GpAlert>
      <GpPasswordInput
        ref="input"
        :model-value="password"
        input-id="order-login-method-pw"
        autocomplete="new-password"
        name="password"
        label="Enter your password"
        :error="isActive && (password == null || password === '') ? 'No password provided!' : ''"
        @update:model-value="handlePasswordInput"
      />
    </div>
  </GpCard>
</template>

<style scoped></style>
